<template>
  <a :href="this.downloadConsoleAppLink" target='_blank' class="link_menu fr is_m_show"><span class="menu_txt">{{ $t('AppDownload') }}</span></a>
</template>

<script>
import ConsoleAppDownloadCommon from '../ConsoleAppDownload.mixin'

export default {
  mixins: [ConsoleAppDownloadCommon]
}
</script>
